import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'

import { getAllProductsAtQuays, getProductUnit } from '../../../../utils/general'

export default class AdditionalInformation extends PureComponent {
  static propTypes = {
    terminalVisit: PropTypes.object.isRequired,
    order: PropTypes.object.isRequired,
    displayFields: PropTypes.array,
    quays: PropTypes.array.isRequired
  }

  products = getAllProductsAtQuays(this.props.quays)
  render() {
    return (
      <div className="ship-details-wrapper">
        <ul>
          <li>
            {this.props.order.operation === 'unloading' ? (
              <i className="fa fa-arrow-up" aria-hidden="true" />
            ) : (
              <i className="fa fa-arrow-down" aria-hidden="true" />
            )}
            {this.props.order.amount
              ? ` ${this.props.order.amount} ${getProductUnit(this.products, this.props.order.product)} `
              : '(no cargo specified)'}
            {this.renderFirstAdditionalInformationField()}
          </li>

          {this.renderAdditionalFields()}
        </ul>
      </div>
    )
  }
  renderFirstAdditionalInformationField = () => {
    const { terminalVisit, order, displayFields } = this.props
    if (displayFields && displayFields.length) {
      const value = getAdditionalField(terminalVisit, order, displayFields[0])
      if (value !== null && value !== undefined) {
        return '- ' + String(value)
      }
    }
    return null
  }

  renderAdditionalFields = () => {
    const { terminalVisit, order, displayFields } = this.props
    if (displayFields && displayFields.length > 1) {
      return (
        <li>
          <ul>
            {displayFields.slice(1).map(displayField => {
              const value = getAdditionalField(terminalVisit, order, displayField)
              if (value) {
                return <li key={displayField}>{value}</li>
              }
              return null
            })}
          </ul>
        </li>
      )
    }
    return null
  }
}

/**
 * Pick additional field from order, administrativeInfo, or terminalVisit
 * @param {TerminalVisit} terminalVisit
 * @param {Order} order
 * @param {string} displayField
 * @return {*}
 */
function getAdditionalField(terminalVisit, order, displayField) {
  // FIXME: this is fuzzy: try to pick from order, administrativeInfo, or terminalVisit. Make it explicit where the field should come from
  // (difficulty here is that there can be multiple orders)
  return get(order, displayField, get(order.administrativeInfo, displayField, get(terminalVisit, displayField)))
}
